import React from 'react';
import { screenSmMax, screenSmMin, screenXxsMax, spacer12, spacer24, spacer48, Type, } from '@spotify-internal/encore-web';
import styled from 'styled-components';
import { Link } from '../Link/Link';
import { FooterTextLink } from './Link';
import { trackCat } from './constants';
import { isMastheadLinkList, isMastheadLinkListItem, } from '../../utils/contentful';
import { trackingAttributes } from '../../lib/buildTrackingAttributes';
import { isNotUndefined } from '../../lib/isNotUndefined';
const ColumnsContainer = styled.div `
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px;
  gap: ${spacer24};
  flex: none;
  align-self: stretch;
  flex-grow: 0;
  width: 58%;
  @media (max-width: ${screenSmMax}) {
    order: 1;
    width: 100%;
  }
  @media (max-width: ${screenXxsMax}) {
    order: 1;
    width: 100%;
    flex-direction: column;
    gap: ${spacer48};
  }
`;
const Column = styled.div `
  display: flex;
  flex-direction: column;
  padding: 0px;
  gap: ${spacer24};
  flex: none;
  flex-grow: 0;
  &:first-of-type {
    order: 1;
    @media (max-width: ${screenSmMax}) {
      order: 0;
    }
    // calculation accounts for gap
    width: calc((28% - 16px));
    @media (min-width: ${screenSmMin}) and (max-width: ${screenSmMax}) {
      // calculation accounts for gap
      width: calc(38% - 16px);
    }
    @media (max-width: ${screenXxsMax}) {
      width: 100%;
    }
  }
  :not(:first-of-type),
  :not(:last-of-type) {
    order: 2;
    @media (max-width: ${screenSmMax}) {
      order: 1;
    }
    @media (min-width: ${screenSmMin}) and (max-width: ${screenSmMax}) {
      // calculation accounts for gap
      width: calc(38% - 16px);
    }
    @media (max-width: ${screenXxsMax}) {
      width: 100%;
    }
  }
  &:last-of-type {
    order: 3;
    @media (max-width: ${screenSmMax}) {
      order: 2;
    }
    // calculation accounts for gap
    width: calc(44% - 16px);
    @media (min-width: ${screenSmMin}) and (max-width: ${screenSmMax}) {
      // calculation accounts for gap
      width: calc(24% - 16px);
    }
    @media (max-width: ${screenXxsMax}) {
      width: 100%;
    }
  }
`;
const FooterImageLink = styled(Link) `
  &:focus {
    outline: 5px auto -webkit-focus-ring-color;
    outline-offset: -2px;
  }
`;
const FooterImage = styled.img `
  display: block;
  max-inline-size: 100%;
  block-size: auto;
`;
const LinkList = styled.div `
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;

  & ${FooterTextLink}:not(:last-child) {
    margin-bottom: ${spacer24};
  }

  & ${FooterImageLink}:not(:last-child) {
    margin-bottom: ${spacer12};
  }
`;
const StyledType = styled(Type) `
  text-transform: uppercase;
`;
export const FooterContent = ({ colors, footerEntry }) => {
    const getLinkData = (linkListItemEntry) => {
        const link = linkListItemEntry.fields.mastheadLink;
        return {
            openInNewWindow: link.fields.target === 'blank',
            href: link.fields.href,
            title: link.fields.title,
            trackingAttributes: trackingAttributes(trackCat, link.fields.trackingId),
            variant: link.fields.variant,
            imageUrl: link.fields.image && link.fields.image.fields.file.url,
        };
    };
    const renderFooterContentItem = (link) => {
        if (link.variant === 'text') {
            return (React.createElement(FooterTextLink, { key: link.title, href: link.href, trackingAttributes: link.trackingAttributes, colors: colors, openInNewWindow: link.openInNewWindow }, link.title));
        }
        if (link.variant === 'rectangularImage') {
            return (React.createElement(FooterImageLink, { openInNewWindow: link.openInNewWindow, href: link.href, trackingAttributes: link.trackingAttributes, key: link.title },
                React.createElement(FooterImage, { src: link.imageUrl, alt: link.title })));
        }
        return null;
    };
    return (React.createElement(ColumnsContainer, null, footerEntry.fields
        .columns.filter(isNotUndefined)
        .filter(isMastheadLinkList)
        .map((item, i) => {
        const links = (item.fields.entries || [])
            .filter(isMastheadLinkListItem)
            .map(getLinkData);
        return (React.createElement(Column, { key: `${item.fields.label}-${i}` },
            React.createElement(StyledType, { variant: "finaleBold" }, item.fields.label),
            React.createElement(LinkList, null, links.map(renderFooterContentItem))));
    })));
};
//# sourceMappingURL=Content.js.map